@if (results | async; as resultats) {
  @if (resultats.length !== 0) {
    <div class="row-details search-item">
      <div class="icon-type">
        <aa-icon-circle class="blue duotone" [faIcon]="'fas ' + category.icon">
        </aa-icon-circle>
      </div>
      <div>{{ category.application | translate }} / {{ category.module | translate }}</div>
    </div>
    @for (result of resultats; track result) {
      <aa-search-result-item [searchResult]="result">
      </aa-search-result-item>
    }
  }
}
